import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          未删减版资源更新快讯，不错过每一次新发现
        </p>
        <div className="relative pl-8 border-l-2 border-background-200 space-y-6">
          {updatesData.map((item) => (
            <div key={item.id} className="relative">
              <span className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></span>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <span className="text-xs px-1.5 py-0.5 rounded bg-accent-500/10 text-accent-400 whitespace-nowrap self-start">
                  {item.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}